(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-banner-v1"] && !window.DesignMode) return;
  try {
    
  const bannerItemLink = document.querySelectorAll('.banner-item-link');
  const bannerPopupAll = document.querySelectorAll('.banner-popup');
  const closePopupAll = document.querySelectorAll('.close-popup');
  const popupOverlay = document.querySelector('.popup-overlay');

  bannerItemLink.forEach((item, index) => {
    item.addEventListener('click', () => {
      bannerPopupAll.forEach(item => {
        !item.classList.contains('popup-hidden')
          ? item.classList.add('popup-hidden')
          : '';
        popupOverlay.classList.add('popup-hidden');
      });
      bannerPopupAll[index].classList.contains('popup-hidden')
        ? bannerPopupAll[index].classList.remove('popup-hidden')
        : '';
      popupOverlay.classList.remove('popup-hidden');
    });
  });
  closePopupAll.forEach((item, index) => {
    item.addEventListener('click', () => {
      !bannerPopupAll[index].classList.contains('popup-hidden')
        ? bannerPopupAll[index].classList.add('popup-hidden')
        : '';
      popupOverlay.classList.add('popup-hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steed-home-tab-section"] && !window.DesignMode) return;
  try {
    
  const steedTabSelection = document.querySelectorAll(".steed-top-selection");


  steedTabSelection.forEach(item => {

    const steedTabHeading = item.querySelectorAll(".steed-section-tab-element .steed-section-tab-link");
    const steedTabContainer = item.querySelectorAll(".steed-section-tab-content__element");
    const steedSlideImage = item.querySelectorAll(".steed-section-tab-content__image-container img");

    window.onload = function() {
      steedTabContainer[0].style.display = "block";
      steedTabContainer[1].style.display = "none";
      steedTabContainer[2].style.display = "none";
      steedTabHeading[0].style.opacity = 1;
      steedTabHeading[1].style.opacity = 0.4;
      steedTabHeading[2].style.opacity = 0.4;
      steedSlideImage[0].style.transform = "translate(3em, 0)";
      steedSlideImage[1].style.transform = "unset";
      steedSlideImage[2].style.transform = "unset";
    };

    item.addEventListener('mouseenter', ()=>{

      steedTabHeading.forEach((item, index) => {

  		item.addEventListener("click", () => {
  			steedTabContainer.forEach((boxes) => {
  				boxes.style.display = "none";
  			});

  			steedTabContainer[index].style.display = "block";

  			steedSlideImage.forEach((itemI) => {
  				itemI.style.setProperty("transform", "unset");
  			});

  			setTimeout(() => {
  				steedSlideImage[index].style.transform = "translate(3em, 0)";
  			}, "100");

  			steedTabHeading.forEach((itemH) => {
  				itemH.style.opacity = 0.4;
  			});
  			steedTabHeading[index].style.opacity = 1;
  		});
  	});

    });
  });

  } catch(e) { console.error(e); }
})();
})();
